/*@flow*/
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { useEffect, createRef, forwardRef, useState } from 'react';
import ShadowTop from './ShadowTop';
import ShadowBottom from './ShadowBottom';
import setShadowStyle from './setShadowStyle';

const getHeight = (height: string | number | void) => {
  if (typeof height === 'string') return height;
  if (typeof height === 'number') return height + 'px';
  return '0px';
};

type PropsT = { scrollHeight: number, children: React$Node };

const Component = (
  props: PropsT,
  ownRef: { current: null | HTMLElement, ... } | ((null | HTMLElement) => mixed)
) => {
  const { scrollHeight, children, ...rest } = props;
  const scrollRef = createRef();
  const [padBottom, setPadBottom] = useState(0);

  useEffect(() => {
    const onScroll = (e: Event) => {
      const element = e.target;
      if (!(element instanceof Element)) return;

      const { scrollTop, scrollHeight: sh, clientHeight } = element;
      const setShadowTop_Cur = setShadowStyle({
        current: document.querySelector('.ShadowTop'),
      });

      const setShadowBottom_Cur = setShadowStyle({
        current: document.querySelector('.ShadowBottom'),
      });

      if (scrollTop === 0) {
        // Hide shadowTop
        setShadowTop_Cur('none');
      } else if (sh === clientHeight + scrollTop) {
        // Hide shadowBottom
        setShadowBottom_Cur('none');
      } else {
        // Show shadowTop
        setShadowTop_Cur('block');
        // Show shadowBottom
        setShadowBottom_Cur('block');
      }
    };
    if (scrollRef.current) {
      scrollRef.current.addEventListener('scroll', onScroll, {
        passive: true,
      });
    }
    return () => {
      if (!scrollRef.current) return;
      scrollRef.current.removeEventListener('scroll', onScroll);
    };
  }, []);

  useEffect(() => {
    const element = scrollRef.current;
    if (element) {
      const { scrollHeight: sh, clientHeight } = element;
      if (sh > clientHeight) {
        setPadBottom(clientHeight - clientHeight * 0.2);
      }
    }
  }, [scrollRef]);

  return (
    <div
      {...rest}
      ref={ownRef}
      css={css(`
        position: relative;
        overflow: hidden;
        height: ${getHeight(scrollHeight)};
      `)}
    >
      <ShadowTop className="ShadowTop" />
      <ShadowBottom className="ShadowBottom" />
      <div
        css={css(`
            overflow-y: scroll;
            -webkit-overflow-scrolling: touch;
            overscroll-behavior: contain;
            padding-bottom: ${padBottom}px;
            height: inherit;
            scroll-snap-type: y mandatory;
        `)}
        ref={scrollRef}
      >
        {children}
      </div>
    </div>
  );
};
export default (forwardRef<PropsT, any>(Component): React$AbstractComponent<PropsT, any>);
